module.exports = __webpack_public_path__ + "static/media/ghost.b174890c.svg";